import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOMeta from '@/components/feature/SEOMeta';


const siteUrl = 'https://fanqiemanhua.com';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '番茄漫画',
  url: siteUrl,
  description: '番茄漫画 - 追更漫画连载更新平台，提供最新话追漫提醒，免费全集完结韩漫日漫国漫在线阅读。',
  foundingDate: '2023',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@fanqiemanhua.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '番茄漫画是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番茄漫画是一个专注追更漫画连载更新的在线阅读平台，提供日漫、韩漫、国漫等分类的免费漫画资源，采用流畅的下拉式滚动阅读模式，为漫迷打造极致阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '番茄漫画的漫画资源是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，番茄漫画上所有漫画作品均免费提供在线阅读，无需付费即可享受完整阅读体验。',
      },
    },
    {
      '@type': 'Question',
      name: '番茄漫画支持哪些类型的漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '番茄漫画涵盖日漫、韩漫、国漫三大分类，包括热血、战斗、奇幻、爱情、搞笑、悬疑、武侠、系统流等多种题材。',
      },
    },
  ],
};

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotInput && honeypotInput.value.trim()) {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }

    const formData = new FormData(form);

    const formUrl = 'https://readdy.ai/api/form/d9onrp8senbniolesih0';

    try {
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = (parsed as Record<string, string> | null)?.meta?.message
          || (parsed as Record<string, string> | null)?.message
          || '提交失败，请稍后重试';
        if (typeof msg === 'string' && msg.toLowerCase().includes('spam')) {
          setFormStatus('success');
          form.reset();
        } else {
          setFormError(typeof msg === 'string' ? msg : '提交失败');
          setFormStatus('error');
        }
      }
    } catch {
      setFormError('网络异常，请稍后再试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <SEOMeta
        title="关于我们 - 番茄漫画 | 追更漫画连载更新平台介绍与联系方式"
        description="番茄漫画关于我们页面，了解番茄漫画品牌故事、平台口碑评价以及联系方式。番茄漫画专注追更漫画连载更新，提供免费全集完结韩漫日漫国漫在线阅读。"
        keywords="番茄漫画,关于我们,漫画平台,追更漫画,联系方式,品牌介绍,免费漫画平台"
        canonicalUrl={`${siteUrl}/about`}
        schema={{ ...orgSchema, ...faqSchema }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

          <section className="py-10 md:py-14">
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                关于<span className="text-primary-500">番茄漫画</span>
              </h1>
              <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                追更漫画从不掉队 — 你的随身追漫伙伴
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-16">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌故事
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  番茄漫画诞生于2023年，由一群热爱漫画的年轻人共同创立。我们深知漫迷追更时等待更新的煎熬，因此打造了这个专注<strong>追更漫画连载更新</strong>的平台。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  平台汇集了<strong>日漫、韩漫、国漫</strong>三大分类的热门作品，从热血战斗到甜蜜爱情，从奇幻冒险到悬疑推理，总有一部能击中你的心。我们采用<strong>流畅的下拉式滚动阅读</strong>模式，让你无需翻页，一滑到底，沉浸式享受每一格画面。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  更重要的是，番茄漫画始终坚守<strong>免费阅读</strong>的初心。所有作品均可免费畅读，我们不设付费墙，只为让每一位漫迷都能无门槛地享受漫画带来的快乐。
                </p>
              </div>
              <div className="rounded-xl overflow-hidden aspect-video bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20modern%20reading%20space%20with%20comic%20books%20and%20manga%20on%20wooden%20shelves%2C%20warm%20orange%20ambient%20lighting%2C%20comfortable%20reading%20nook%20with%20cushions%2C%20artistic%20creative%20atmosphere%2C%20editorial%20photography%20style%20with%20soft%20focus&width=800&height=450&seq=fqmh-brand-story&orientation=landscape"
                  alt="番茄漫画品牌故事"
                  title="番茄漫画 - 品牌故事 | 追更漫画连载更新平台"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                为什么选择我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  { icon: 'ri-flashlight-line', title: '极速更新', desc: '热门连载第一时间更新，追更提醒让你永远走在最前线' },
                  { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '所有漫画资源免费阅读，无隐藏付费，无VIP限制' },
                  { icon: 'ri-smartphone-line', title: '全平台适配', desc: '电脑、平板、手机全适配，随时随地流畅阅读' },
                  { icon: 'ri-file-list-2-line', title: '下拉式阅读', desc: '独创纵向滚动阅读体验，无需翻页，一气呵成' },
                  { icon: 'ri-bookmark-line', title: '海量资源', desc: '日漫、韩漫、国漫全收录，热门冷门一网打尽' },
                  { icon: 'ri-heart-pulse-line', title: '漫迷社区', desc: '活跃的漫迷社区氛围，一起讨论剧情分享心得' },
                ].map((item) => (
                  <div key={item.title} className="p-6 rounded-xl bg-background-100">
                    <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center mb-4">
                      <i className={`${item.icon} text-xl text-primary-500`}></i>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-950 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  { text: '用了番茄漫画之后就再也没换过别的平台，更新速度真的快，而且完全免费，良心！', author: '追漫达人小王', stars: 5 },
                  { text: '下拉式阅读体验太舒服了，看条漫的时候简直停不下来。分类也很清晰，找漫画超方便。', author: '日漫爱好者KK', stars: 5 },
                  { text: '作为一个韩漫粉，番茄漫画的韩漫资源更新非常及时，画质清晰，强烈推荐！', author: '韩漫迷妹', stars: 4 },
                ].map((review) => (
                  <div key={review.author} className="p-6 rounded-xl bg-background-100">
                    <div className="flex items-center gap-0.5 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className={`text-sm ${i < review.stars ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">"{review.text}"</p>
                    <p className="text-xs font-semibold text-foreground-800">{review.author}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  联系我们
                </h2>
                <div className="flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                      <i className="ri-mail-line text-primary-500"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">contact@fanqiemanhua.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                      <i className="ri-wechat-line text-primary-500"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">微信公众号</p>
                      <p className="text-sm font-medium text-foreground-800">番茄漫画官方</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                      <i className="ri-weibo-line text-primary-500"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">微博</p>
                      <p className="text-sm font-medium text-foreground-800">@番茄漫画</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  留言反馈
                </h2>
                <form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-4 p-6 rounded-xl bg-background-100"
                  data-readdy-form=""
                >
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="你的邮箱"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <textarea
                    name="message"
                    placeholder="写下你想说的话..."
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                  ></textarea>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-honeypot"
                  />
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                  {formStatus === 'success' && (
                    <p className="text-xs text-accent-500 text-center">留言已发送，我们会尽快回复你！</p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-xs text-red-500 text-center">{formError || '发送失败，请稍后重试'}</p>
                  )}
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}